export default __webpack_public_path__ + "static/media/modern-calligraphy-wholesale.453187d8.png";